module.exports = __webpack_public_path__ + "img/unity_shader.1fb9d7a4.gif";